export const Calendar = `
<path fill-rule="evenodd" clip-rule="evenodd" d="M819.2 161.684V53.8947C819.2 24.1295 796.277 0 768 0C739.723 0 716.8 24.1295 716.8 53.8947V161.684H307.2V53.8947C307.2 24.1295 284.277 0 256 0C227.723 0 204.8 24.1295 204.8 53.8947V161.684H0V1024H1024V161.684H819.2ZM307.2 754.526H204.8V646.737H307.2V754.526ZM204.8 538.947H307.2V431.158H204.8V538.947ZM563.2 754.526H460.8V646.737H563.2V754.526ZM460.8 538.947H563.2V431.158H460.8V538.947ZM716.8 754.526V646.737H819.2V754.526H716.8ZM716.8 431.158V538.947H819.2V431.158H716.8Z"/>
`;



// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/icons/calendar.js